module.exports = __webpack_public_path__ + "static/media/historia-header.abe4e2c7.jpg";